
require("../../../../Button/Button.st.css.js");
require("../../Foundations/colors.st.css.js");
const { classesRuntime, statesRuntime } = require("./../../../../stylable-cjs-runtime.js");



var _namespace_ = "wds_1_146_2_BrandButton";
var _style_ = classesRuntime.bind(null, _namespace_);

module.exports.cssStates = statesRuntime.bind(null, _namespace_);
module.exports.style = _style_;
module.exports.st = _style_;

module.exports.namespace = _namespace_;
module.exports.classes = {"root":"wds_1_146_2_BrandButton__root"};
module.exports.keyframes = {}; 
module.exports.layers = {};
module.exports.containers = {};
module.exports.stVars = {}; 
module.exports.vars = {}; 




